'use client'

import { SellerProfileLexicalRichText } from '@/app/buy/seller/[sellerSlug]/content/SellerProfileLexicalRichText'

import type { CmsTermsBody } from '../cmsTerms'
import { Body } from './ui'

/**
 * The CMS-authored accept-terms body, rendered where the hardcoded per-seller points sit.
 * No signup CTA tracking: only a signed-in buyer ever reaches this page.
 */
export const CmsTermsPoints = ({ body }: { body: CmsTermsBody }) => (
  <Body data-testid="CmsTermsPoints">
    <SellerProfileLexicalRichText data={body} />
  </Body>
)
